import Image from 'next/image';
import styled, { css } from 'styled-components';

import { Button } from '@/styled/button.styled';

export const FlexibleDiv = styled.div`
  display: flex;
`;
export const FlexCenterAligned = styled(FlexibleDiv)`
  align-items: center;
  justify-content: center;
`;
export const FlexAligned = styled(FlexibleDiv)`
  align-items: center;
`;
export const FlexColumn = styled(FlexibleDiv)`
  flex-direction: column;
`;
export const FlexColumnCenterAligned = styled(FlexColumn)`
  align-items: center;
  justify-content: center;
`;
export const FlexBetween = styled(FlexibleDiv)`
  justify-content: space-between;
  align-items: center;
`;
export const FlexLink = styled.a`
  display: flex;
  text-decoration: none;
`;
export const FlexCenterAlignedLink = styled(FlexLink)`
  align-items: center;
  justify-content: center;
`;
export const FlexAlignedLink = styled(FlexLink)`
  align-items: center;
`;

export const FlexBetweenLink = styled(FlexLink)`
  justify-content: space-between;
  align-items: center;
`;

export const ImageCircle = styled.div<{ $imageUrl: string }>`
  background-color: ${({ theme }) => theme.text.secondary};
  border-radius: 50%;
  position: relative;
  background-image: ${({ $imageUrl }) => `url(${$imageUrl})`};
  flex-shrink: 0;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
`;

export const ellipsisText = css`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const linkHoverEffect = css`
  &:hover {
    background-color: ${({ theme }) => theme.bg.secondary};
  }
`;

export const multilineEllipsis = (linesToShow = 2) => css`
  display: block;
  display: -webkit-box;
  max-height: ${linesToShow * 1.2}em;
  line-height: normal;
  -webkit-line-clamp: ${linesToShow};
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const EllipsisText = styled.div`
  ${ellipsisText};
`;

export const LayoutContainer = styled(FlexibleDiv)`
  padding: 0;
  margin: 0;
  height: calc(100vh - 75px);
  flex-grow: 1;
  width: 100vw;
  max-width: 100vw;
  overflow: hidden;
`;

export const UnselectedConversationContainer = styled(FlexCenterAligned)`
  text-align: center;
  background-color: ${({ theme }) => theme.bg.main};
  color: ${({ theme }) => theme.text.main};
  font-weight: 400;
  font-size: 15px;
  width: 100%;
`;

export const PlaceholderText = styled.div`
  max-width: 313px;
`;

export const FilledNextImage = styled(Image)`
  position: absolute;
  inset: 0 0 0 0;
  object-fit: cover;
`;

export const FilledNextImageContainer = styled.div`
  position: relative;
  width: 34px;
  height: 34px;
  overflow: hidden;
  border-radius: 50%;
`;

export const textStyles = css`
  color: ${({ theme }) => theme.text.main};
  font-size: 15px;
`;
export const TextSpanBlack = styled.span<{ $align?: string }>`
  text-align: ${({ $align }) => $align || 'initial'};
  ${textStyles};
  width: 100%;
`;

export const LoginContainer = styled(FlexColumnCenterAligned)`
  width: 100%;
  height: 100%;
  gap: 20px;
  margin: auto;
`;

export const ButtonWithIcon = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 44px;
  height: 44px;
  padding: 0;
  transition: background-color ease-in-out 0.2s;
  border-radius: 14px;

  &:hover {
    background-color: ${({ theme }) => theme.bg.quaternary};
  }
`;

export const openingEffect = () => css<{
  $isOpen: boolean;
}>`
  transition:
    opacity 0.3s ease,
    transform 0.3s ease,
    visibility 0.3s;

  ${({ $isOpen }) =>
    $isOpen
      ? css`
          visibility: visible;
          opacity: 1;
        `
      : css`
          visibility: hidden;
          opacity: 0;
        `}
`;
